import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NumberQuestionEntry } from '@entscheidungsnavi/api-types';
import { ControlContainer, FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FORWARD_CONTROL_CONTAINER } from '../../../form-elements';
import { InputSpinnerComponent } from '../../../spinners';

@Component({
  selector: 'dt-questionnaire-question-number',
  templateUrl: './questionnaire-number.component.html',
  styleUrls: ['./questionnaire-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [FORWARD_CONTROL_CONTAINER],
  imports: [MatFormField, MatLabel, InputSpinnerComponent, MatInput, ReactiveFormsModule, MatHint, MatError],
})
export class QuestionnaireQuestionNumberComponent {
  @Input()
  entry: NumberQuestionEntry;

  @Input()
  formIndex: number;

  get control() {
    return (this.controlContainer.control as FormArray).at(this.formIndex) as FormControl<number>;
  }

  get errors() {
    return this.control.errors;
  }

  constructor(protected controlContainer: ControlContainer) {}

  increment() {
    this.control.setValue(Math.min(this.entry.max ?? Infinity, this.control.value + this.entry.step));
  }

  decrement() {
    this.control.setValue(Math.max(this.entry.min ?? -Infinity, this.control.value - this.entry.step));
  }
}
